import CategoryIcon from "@mui/icons-material/Category";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import ReceiptIcon from "@mui/icons-material/Receipt";
import { Button, CircularProgress, useMediaQuery } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import PageTitle from "../../components/pageTitle";
import { handleAllBuySummeryData } from "../../redux/actoin";
import { API } from "../../scripts/api";
import axiosInstance from "../../scripts/axiosInspector";
import HeaderReq from "../../scripts/functions/headerReq";

const Buy = () => {
  const [loadingInfo, setLoadingInfo] = useState(false);

  const [info, setInfo] = useState({});
  const CurrentCompany = useSelector((state) => state.CurrentCompany);
  const { company } = CurrentCompany;
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  const dispatch = useDispatch();
  const isMd = useMediaQuery("(min-width:756px)");
  const AllSummeryBuy = useSelector((state) => state.AllSummeryBuy);
  useEffect(() => {
    if (userInfo) {
      if (
        AllSummeryBuy?.summery &&
        Object.keys(AllSummeryBuy?.summery).length !== 0
      ) {
        setInfo(AllSummeryBuy?.summery);
      } else {
        setLoadingInfo(true);

        axiosInstance
          .get(
            API.pub.purch + `?guidStateRecNo=${company?.guidRecNo}`,
            HeaderReq(userInfo?.token)
          )
          .then((res) => {
            dispatch(handleAllBuySummeryData(res?.data?.data));
            setInfo(res?.data?.data);
            setLoadingInfo(false);
          })
          .catch((err) => {
            setLoadingInfo(false);
          });
      }
    }
  }, [userInfo, company?.guidRecNo]);
  return (
    <>
      <PageTitle title={"خرید"} />
      <div className="mx-3 min-h-[60vh] mt-6  relative z-50">
        <div className="shadow-xl rounded-md border bg-white w-full max-w-[400px] mx-auto pt-1 pb-3 px-4 grid md:grid-cols-3 grid-cols-2">
          <div className="md:col-span-3 col-span-2 font-bold text-sm flex mt-2 mb-4 justify-center items-center text-main">
            خلاصه فعالیت
          </div>
          <div className="flex flex-col col-span-1 gap-3">
            <span className="text-[10px] text-center">
              میانگین خرید ماه های قبل
            </span>
            <span className="text-sm font-bold text-center">
              {loadingInfo ? (
                <CircularProgress size={15} />
              ) : (
                <>
                  {info?.moInvoicePurch_TotalBillPrice_AvgPerMonth?.toLocaleString(
                    "en-US"
                  )}
                </>
              )}
            </span>
          </div>
          <div
            className={"flex  md:border-r md:border-l px-2 mx-2 flex-col gap-3"}
          >
            <span className={`text-[10px] text-center`}>خرید این ماه</span>
            <span
              className={`text-sm font-bold text-center ${
                info?.moInvoicePurch_TotalBillPrice_AvgPerMonth >
                info?.moInvoicePurch_TotalBillPrice_ThisMonth
                  ? "text-yellow-400"
                  : "text-main"
              }`}
            >
              {loadingInfo ? (
                <CircularProgress size={15} />
              ) : (
                <>
                  {" "}
                  {info?.moInvoicePurch_TotalBillPrice_ThisMonth?.toLocaleString(
                    "en-US"
                  )}
                </>
              )}
            </span>
          </div>{" "}
          <div className="flex flex-col gap-3 border-t mt-2 pt-2 md:border-t-0 md:pt-0 md:mt-0 md:col-span-1 col-span-2">
            <span className="text-[10px] text-center">خرید سال</span>
            <span className="text-sm font-bold text-center">
              {loadingInfo ? (
                <CircularProgress size={15} />
              ) : (
                <>
                  {" "}
                  {info?.moInvoicePurch_TotalBillPrice_ThisYear?.toLocaleString(
                    "en-US"
                  )}
                </>
              )}
            </span>
          </div>
        </div>
        <div className="grid p-4 mt-8 md:grid-cols-3 sm:grid-cols-3 grid-cols-3 gap-3">
          <Link to="/buy/products">
            {" "}
            <Button
              color="inherit"
              className="flex gap-2 items-center"
              sx={{
                boxShadow: "0px 11px 38px rgba(0,0,0,0.18)",
                background: (theme) =>
                  theme.palette.mode === "dark" ? "#2a3042" : "#fff",
                display: "flex",
                flexDirection: "column",
              }}
              fullWidth
            >
              <CategoryIcon className="text-main" />
              {loadingInfo ? (
                <CircularProgress size={18} />
              ) : (
                <span className="font-bold">{info?.intPurchStuffCount}</span>
              )}

              <span className="text-sm font-light">کالا/خدمت</span>
            </Button>
          </Link>{" "}
          <Link to="/buy/customer">
            {" "}
            <Button
              color="inherit"
              className="flex gap-2 items-center"
              sx={{
                boxShadow: "0px 11px 38px rgba(0,0,0,0.18)",
                background: (theme) =>
                  theme.palette.mode === "dark" ? "#2a3042" : "#fff",
                display: "flex",
                flexDirection: "column",
              }}
              fullWidth
            >
              <PersonOutlineIcon className="text-main" />
              {loadingInfo ? (
                <CircularProgress size={18} />
              ) : (
                <span className="font-bold">{info?.intSellerCount}</span>
              )}

              <span className="text-sm font-light">فروشندگان</span>
            </Button>
          </Link>
          <Link to="/buy/invoice">
            {" "}
            <Button
              color="inherit"
              className="flex gap-2 items-center"
              sx={{
                boxShadow: "0px 11px 38px rgba(0,0,0,0.18)",
                background: (theme) =>
                  theme.palette.mode === "dark" ? "#2a3042" : "#fff",
                display: "flex",
                flexDirection: "column",
              }}
              fullWidth
            >
              <ReceiptIcon className="text-main" />{" "}
              {loadingInfo ? (
                <CircularProgress size={18} />
              ) : (
                <span className="font-bold">{info?.intInvoicePurchCount}</span>
              )}{" "}
              <span className="text-sm font-light">صورتحساب </span>
            </Button>
          </Link>
        </div>{" "}
      </div>
    </>
  );
};

export default Buy;
